import React, {ReactElement, ReactNode, useState} from "react";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import {
    Container,
    TitleContainer,
    Title,
    ArrowIconContainer,
    ContentContainer,
    IconImage,
    PreviewContainer
} from './CollapsableContainer.styles'

interface CollapsableContainerProps {
    title: string,
    defaultIsOpen?: boolean,
    children?: ReactNode
    icon?: string;
    backgroundColor?: string;
    noBorder?: boolean
    preview?: ReactNode
    fullPreview?: boolean
    isCollapsable?: boolean;
}

const CollapsableContainer: React.FC<CollapsableContainerProps> = ({ title, icon, backgroundColor, noBorder, defaultIsOpen = false, children, preview, fullPreview = false, isCollapsable = true }: CollapsableContainerProps) => {
    const [isOpen, setIsOpen] = useState(defaultIsOpen)

    const effectivelyOpen = isCollapsable ? isOpen : true;

    const handleTitleClick = () => {
        if (isCollapsable) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <Container $backgroundColor={backgroundColor}>
            <TitleContainer className="no-fastclick" onClick={handleTitleClick} $noBorder={noBorder}>
                <Title>{icon &&  <IconImage src={icon} alt="Icon" width={'75%'}/>} {title}</Title>
                {isCollapsable && (
                <ArrowIconContainer>{isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}</ArrowIconContainer>
                )}
            </TitleContainer>
            {effectivelyOpen ? <ContentContainer>
                {children}
            </ContentContainer>
                : <>{fullPreview
                    ? <>{preview}...</>
                    : preview ? <><PreviewContainer>{preview}</PreviewContainer>...</> : null
                }</>}
        </Container>
    )
}

export default CollapsableContainer;
